import React, { Component } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import OwlCarousel from 'react-owl-carousel';
import { NavLink, withRouter, Link } from 'react-router-dom'

//Imagenes
import terma from '../../../assets/img/terma.png';

//CSS
import '../LandingSubcomponents/Inicio.css';
import { fetchPromocionesIfNeeded } from "../../../actions/PromocionesActions";
import { connect } from "react-redux";

class Inicio extends Component {
    constructor(props) {
        super(props)
    }


    componentDidMount() {
        this.props.fetchPromocionesIfNeeded();
    }

    render() {

        let promocion = null;
        // let producto = null;

        let promociones = this.props.promociones.allIds.map((idPromo) => {
            promocion = this.props.promociones.byId.promociones[idPromo];
            let productoPromocion = this.props.productosPromocion.byId.productosPromocion[promocion.producto_promocion[0]] ? this.props.productosPromocion.byId.productosPromocion[promocion.producto_promocion[0]] : null;
            let producto = this.props.productos.byId.productos[productoPromocion.codProducto] ? this.props.productos.byId.productos[productoPromocion.codProducto] : null;
            console.log({ producto });
            if (promocion.portada == 1) {
                return (
                    <div className="item">
                        <div className="item-container">
                            <img
                                // src={process.env.PUBLIC_URL + "/promo-img/" + promocion.imgPromo}
                                src={promocion.imgPromo ? process.env.PUBLIC_URL + "/promo-img/" + promocion.imgPromo : "https://secure.sig2k.com/webs/myfsrl@sigma.defaultKart/sigkart/3.1/imagen.php?fotoid=" + producto.codArticuloWeb + "&auto=300"}
                                className="producto-imagen" alt="" />
                            <div className="producto-informacion">
                                <h2>
                                    {promocion.nombrePromo.toLowerCase()}
                                </h2>
                                <h4 style={{ fontSize: "20px", marginTop: 0 }}>
                                    {
                                        promocion.lanzamiento == 1 &&
                                        <b>¡Lanzamiento! 🔥</b>
                                    }
                                </h4>
                                <div>
                                    <h3>
                                        {promocion.descuento > 0 ? promocion.descuento + "%" : <br />}
                                    </h3>
                                    <h4>
                                        {promocion.descuento > 0 ? "de descuento" : <br />}
                                    </h4>
                                </div>
                                <NavLink to="/promociones">
                                    <Button className="btn-primary">
                                        Ver Más
                                    </Button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                )
            }
        });

        return (

            <div className="portada-container">
                <div id="inicio" className="inicio">
                    <div className="container-inicio">
                        <h1>Servicio de Distribución</h1>
                        <h3>Autoservicios, Almacenes y Comercios Minoristas</h3>
                        <h4>Conocé todas las promociones del mes</h4>
                        <Link to="/promociones">
                            <Button>Ofertas</Button>
                        </Link>
                    </div>
                </div>
                <div className="muestrario">
                    {promociones.length > 0 ?
                        <OwlCarousel
                            className="owl-theme"
                            loop
                            nav
                            dots={false}
                            margin={20}
                            items={1}
                            responsive={
                                {
                                    0: {
                                        items: 1
                                    },
                                    1024: {
                                        items: 1
                                    },
                                    1200: {
                                        items: 2
                                    }
                                }
                            }
                            autoplay={false}
                            autoplayTimeout={7000}
                            autoplaySpeed={3500}
                            navText=""
                        >

                            {promociones}
                        </OwlCarousel> : null}
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        promociones: state.promociones,
        productos: state.productos,
        categorias: state.categorias,
        productosPromocion: state.productosPromocion,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPromocionesIfNeeded: () => {
            dispatch(fetchPromocionesIfNeeded());
        },
    }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Inicio));



// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Inicio.js